export default __webpack_public_path__ + "img/fIPdOlQC.816c53a0.svg";